module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctbox"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "id": "ctboxid",
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入手机号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    on: {
      "click": _vm.handleSubmit2
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "title",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注册账号")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "title",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("\n            欢迎登陆上海邦邦机器人后台管理系统\n        ")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "注册账号",
      "visible": _vm.registerOutVisible,
      "width": "600px",
      "center": "",
      "top": "10%"
    },
    on: {
      "update:visible": function($event) {
        _vm.registerOutVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "registerForm",
    attrs: {
      "model": _vm.registerForm,
      "rules": _vm.rules3,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "label-width": "80px",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入姓名，管理员将进行审核",
      "maxlength": 30
    },
    model: {
      value: (_vm.registerForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "nickname", $$v)
      },
      expression: "registerForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "80px",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入手机号",
      "maxlength": 11
    },
    model: {
      value: (_vm.registerForm.username),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "username", $$v)
      },
      expression: "registerForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "label-width": "80px",
      "prop": "vercode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.registerForm.vercode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "vercode", $$v)
      },
      expression: "registerForm.vercode"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.sendDisable
    },
    on: {
      "click": _vm.sendcode
    }
  }, [_vm._v(_vm._s(_vm.btntext))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "label-width": "80px",
      "prop": "pwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入密码(密码长度在 8 到 30 个字符)"
    },
    model: {
      value: (_vm.registerForm.pwd),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "pwd", $$v)
      },
      expression: "registerForm.pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": "80px",
      "prop": "pwdsure"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请再次输入密码"
    },
    model: {
      value: (_vm.registerForm.pwdsure),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "pwdsure", $$v)
      },
      expression: "registerForm.pwdsure"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邀请码",
      "label-width": "80px",
      "prop": "authcode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入邀请码"
    },
    model: {
      value: (_vm.registerForm.authcode),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "authcode", $$v)
      },
      expression: "registerForm.authcode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "30%",
      "title": "提示",
      "visible": _vm.registerInnerVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.registerInnerVisible = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.upmessage('registerForm')
      }
    }
  }, [_vm._v("注 册")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "忘记密码",
      "visible": _vm.forgetOutVisible,
      "width": "600px",
      "center": "",
      "top": "10%"
    },
    on: {
      "update:visible": function($event) {
        _vm.forgetOutVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "forgetForm",
    attrs: {
      "model": _vm.forgetForm,
      "rules": _vm.rules4,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "80px",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入手机号",
      "maxlength": 11
    },
    model: {
      value: (_vm.forgetForm.username),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "username", $$v)
      },
      expression: "forgetForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码",
      "label-width": "80px",
      "prop": "vercode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.forgetForm.vercode),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "vercode", $$v)
      },
      expression: "forgetForm.vercode"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.sendDisable
    },
    on: {
      "click": _vm.sendcode
    }
  }, [_vm._v(_vm._s(_vm.btntext))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码",
      "label-width": "80px",
      "prop": "pwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请输入新密码(密码长度在 8 到 30 个字符)"
    },
    model: {
      value: (_vm.forgetForm.pwd),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "pwd", $$v)
      },
      expression: "forgetForm.pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": "80px",
      "prop": "pwdsure"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "请再次输入密码"
    },
    model: {
      value: (_vm.forgetForm.pwdsure),
      callback: function($$v) {
        _vm.$set(_vm.forgetForm, "pwdsure", $$v)
      },
      expression: "forgetForm.pwdsure"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "30%",
      "title": "提示",
      "visible": _vm.forgetInnerVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.forgetInnerVisible = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.forgetUp('forgetForm')
      }
    }
  }, [_vm._v("确认修改")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7be8cdd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 1288
// module chunks = 1